import React from "react";
import { Box } from "@mui/material";
import { badgeTones } from "../../theme/tokens";

// Compact pill-style badge used for ticket priority/status, compliance, contacts.
export default function Badge({ children, tone = "neutral", sx, ...rest }) {
  const t = badgeTones[tone] || badgeTones.neutral;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: "9px",
        py: "3px",
        borderRadius: "4px",
        fontSize: 10.5,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        whiteSpace: "nowrap",
        backgroundColor: t.bg,
        color: t.fg,
        border: `1px solid ${t.border}`,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
